"use client";

import React from "react";
import { Camera } from "lucide-react";
import { Badge } from "../../badge";
import { UserAvatar } from "../../user-avatar";

interface UserProfileHeaderProps {
  initials: string;
  displayName: string;
  email: string | null | undefined;
  userTypeDisplay: string;
  avatarUrl?: string | null;
  /** Open the "manage profile picture" modal. */
  onManagePicture?: () => void;
}

export function UserProfileHeader({
  initials,
  displayName,
  email,
  userTypeDisplay,
  avatarUrl,
  onManagePicture,
}: UserProfileHeaderProps) {
  return (
    <div className="px-3 py-3 border-b border-border">
      <div className="flex items-center space-x-3">
        {/* Click the photo to manage it. */}
        <button
          type="button"
          onClick={onManagePicture}
          aria-label="Change profile picture"
          className="group/avatar relative rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <UserAvatar avatarUrl={avatarUrl} initials={initials} name={displayName} size="lg" />
          <span className="absolute inset-0 flex items-center justify-center rounded-full bg-black/40 opacity-0 transition-opacity group-hover/avatar:opacity-100 group-focus-visible/avatar:opacity-100">
            <Camera className="h-4 w-4 text-white" />
          </span>
        </button>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-foreground truncate">{displayName}</p>
          <p className="text-sm text-muted-foreground truncate">{email}</p>
          <Badge variant="secondary" className="mt-1 text-xs">
            {userTypeDisplay}
          </Badge>
        </div>
      </div>
    </div>
  );
}
